import { Component, EventEmitter, forwardRef, Inject, OnInit, Output, Input } from '@angular/core';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { FiltersService } from '@app/shared/components/catalog/services/filters.service';
import { connectToggle } from 'instantsearch.js/es/connectors';
import { CatalogWidgetDirective, IBaseItem } from '../catalog-widget';

interface IToggleValue extends IBaseItem {
  onFacetValue?: IToggleValue;
  offFacetValue?: IToggleValue;
}

@Component({
  selector: 'vc-catalog-widget-toggle',
  templateUrl: './catalog-widget-toggle.component.html',
  styleUrls: ['./catalog-widget-toggle.component.scss', '../catalog-widgets.scss']
})
export class CatalogWidgetToggleComponent extends CatalogWidgetDirective implements OnInit {
  public seoUrl;

  state: {
    value: IToggleValue;
    createURL: () => string;
    refine: (value: IToggleValue) => void;
    widgetParams: {};
  };

  @Input()
  currentCountry: string;

  @Output()
  clickFilter = new EventEmitter<any>();

  private toggleValue: number | string = 1;

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent,
    public filtersService: FiltersService
  ) {
    super('CatalogWidgetToggleComponent');
  }

  ngOnInit() {
    if (this.options.facet === 'dsEligibleCountries') {
      this.toggleValue = this.currentCountry;
    }
    this.createWidget(connectToggle, {
      attributeName: this.options.facet,
      label: this.options.facet + '_on',
      values: { on: this.toggleValue, off: undefined }
    });

    if (this.facetLink && this.facetLink.optionDelivery) {
      const f = this.facetLink.optionDelivery.find(facetLink => facetLink.facetId === this.options.facet);
      this.seoUrl = f && f.path;
    }

    super.ngOnInit();
  }

  refineToggle(event: MouseEvent, item: IToggleValue) {
    event.preventDefault();
    event.stopPropagation();

    // refine through Algolia API
    this.state.refine(item);
    this.refined.emit(true);

    // dispatch APPLY_FILTER action to send analytics
    if (!item.onFacetValue.isRefined) {
      this.clickFilter.emit({ filterItem: item, filterOptions: this.options });
    }
  }
}
